<template>
  <div class="version-list" @scroll="debouncedOnScroll">
    <ul>
      <version-list-item v-for="version in versions" :key="version.id" :version="version" />
    </ul>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import VersionListItem from './VersionListItem.vue';

defineProps(['versions']);

const emit = defineEmits(['bottom-reached']);
const debounceTimeout = ref(null);

// watch(versions, (value) => {

// })

const debouncedOnScroll = (event) => {
  if (debounceTimeout.value) clearTimeout(debounceTimeout.value);

  debounceTimeout.value = setTimeout(() => { onScroll(event) }, 200);
}

const onScroll = (event) => {
  const target = event.target;
  const bottomReached = (target.clientHeight + 200 ) + target.scrollTop >= target.scrollHeight;

  if (!bottomReached) return;

  emit('bottom-reached')
}
</script>